import { admin } from "./admin";
import { agents } from "./agents";
import { browse } from "./browse";
import { common } from "./common";
import { device } from "./device";
import { download } from "./download";
import { errors } from "./errors";
import { monitoring } from "./monitoring";
import { nav } from "./nav";
import { notifications } from "./notifications";
import { overview } from "./overview";
import { settings } from "./settings";
import { shell } from "./shell";
import { token } from "./token";

/**
 * The English catalogue, the source of truth: its shape defines `Messages`, and every other language must have
 * exactly the same keys (a missing key is a compile error in that language's catalogue, and a test).
 */
export const en = {
    common,
    nav,
    shell,
    admin,
    agents,
    overview,
    monitoring,
    notifications,
    token,
    settings,
    download,
    device,
    errors,
    browse,
};

/** A catalogue's shape: the nested keys of `en`, every leaf a string. */
type Widen<T> = T extends string ? string : { [K in keyof T]: Widen<T[K]> };
export type Messages = Widen<typeof en>;

type Join<P extends string, K extends string> = `${P}${P extends "" ? "" : "."}${K}`;
type Leaves<T, P extends string = ""> = {
    [K in keyof T & string]: T[K] extends string ? Join<P, K> : Leaves<T[K], Join<P, K>>;
}[keyof T & string];

/** Every dotted key of the catalogue: "agents.card.disable". Typed, so a misspelt key does not compile. */
export type MessageKey = Leaves<Messages>;
